import { notify } from '@kyvg/vue3-notification'

/**
 * Toasts for the Sites dashboard that may carry a router link (the global
 * `error` / `success` / `info` outlets render plain text only). Rendered by
 * `components/Sites/SiteToasts.vue`, mounted in the Sites shell.
 *
 * @param {{ type?: 'info'|'success'|'error', text: string, link?: { to: object, label: string }, duration?: number }} opts
 */
export function notifySite({ type = 'info', text, link = null, duration }) {
	notify({
		group: 'sites',
		type,
		text,
		duration: duration ?? (link ? 9000 : 5000),
		data: link ? { link } : undefined,
	})
}

/** Plans page link for one site. */
export const plansLink = (siteId, label = 'Open Plans') => ({ to: { name: 'SitePlans', params: { siteId } }, label })
